////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const campaignPromo = {
	getCampaignPromo: (idCampaign) => ({
		type: ActionsTypes.GET_CAMPAIGN_PROMO,
		payload: {
			idCampaign,
		},
	}),
	getCampaignPromoSuccess: (data) => ({
		type: ActionsTypes.GET_CAMPAIGN_PROMO_SUCCESS,
		payload: {
			data,
		},
	}),
	getCampaignPromoFailure: (error) => ({
		type: ActionsTypes.GET_CAMPAIGN_PROMO_FAILURE,
		payload: {
			error,
		},
	}),
	createCampaignPromo: (campaign, action) => ({
		type: ActionsTypes.CREATE_CAMPAIGN_PROMO,
		payload: {
			campaign,
			action,
		},
	}),
	createCampaignPromoSuccess: (campaign) => ({
		type: ActionsTypes.CREATE_CAMPAIGN_PROMO_SUCCESS,
		payload: {
			campaign,
		},
	}),
	createCampaignPromoFailure: (error) => ({
		type: ActionsTypes.CREATE_CAMPAIGN_PROMO_FAILURE,
		payload: {
			error,
		},
	}),
	resetCampaignPromo: () => ({
		type: ActionsTypes.RESET_CAMPAIGN_PROMO,
		payload: {},
	}),
	checkCampaignPromo: (campaign, target) => ({
		type: ActionsTypes.POST_CHECK_CAMPAIGN_PROMO,
		payload: {
			campaign,
			target,
		},
	}),
	checkCampaignPromoSuccess: (campaign) => ({
		type: ActionsTypes.POST_CHECK_CAMPAIGN_PROMO_SUCCESS,
		payload: {
			campaign,
		},
	}),
	checkCampaignPromoFailure: (error) => ({
		type: ActionsTypes.POST_CHECK_CAMPAIGN_PROMO_FAILURE,
		payload: {
			error,
		},
	}),
	updateCampaignPromo: (idCampaign, data) => ({
		type: ActionsTypes.UPDATE_CAMPAIGN_PROMO,
		payload: {
			idCampaign,
			data,
		},
	}),
	updateCampaignPromoSuccess: (data, idCampaign) => ({
		type: ActionsTypes.UPDATE_CAMPAIGN_PROMO_SUCCESS,
		payload: {
			data,
			idCampaign,
		},
	}),
	updateCampaignPromoFailure: (error) => ({
		type: ActionsTypes.UPDATE_CAMPAIGN_PROMO_FAILURE,
		payload: {
			error,
		},
	}),
	cancelCampaignPromo: (idCampaign) => ({
		type: ActionsTypes.CANCEL_CAMPAIGN_PROMO,
		payload: {
			idCampaign,
		},
	}),
	cancelCampaignPromoSuccess: (data, idCampaign) => ({
		type: ActionsTypes.CANCEL_CAMPAIGN_PROMO_SUCCESS,
		payload: {
			data,
			idCampaign,
		},
	}),
	cancelCampaignPromoFailure: (error) => ({
		type: ActionsTypes.CANCEL_CAMPAIGN_PROMO_FAILURE,
		payload: {
			error,
		},
	}),
	resetCampaignPromoItems: () => ({
		type: ActionsTypes.RESET_CAMPAIGN_PROMO_ITEMS,
	}),
}

export default campaignPromo
